import React, { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { apiAction, generalSet } from '../../store/generalSlice';
import Spinner from '../../layout/Spinner';
import { TextField, Autocomplete } from '@mui/material';

const NewCondition = () => {
  const dispatch = useDispatch();
  const { tables, columns, loadingColumns, newCondition, loadingNewCondition } = useSelector((state) => state.general);
  const [selectedTables, setSelectedTables] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [conditionName, setConditionName] = useState('');
  const [conditionDesc, setConditionDesc] = useState('');
  useEffect(() => {
    dispatch(apiAction({ reduxField: 'tables', route: 'mmData/getAllTables' }));
  }, []);

  console.log({ tables, selectedTables, columns, loadingColumns, newCondition, selectedColumns });

  if (newCondition?._id) {
    window.location.href = `/condition/${newCondition._id}`;
  }

  return Array.isArray(tables) ? (
    <div className='mb-4'>
      <div className='row d-flex justify-content-center pt-4 pt-lg-0'>
        <div
          className='col-lg-12 d-flex justify-content-center mt-4 pt-lg-0 border-bottom'
          data-aos='fade-up'
          data-aos-delay='200'
        >
          <h1>Create a Condition</h1>
        </div>
        <div className='col-md-6 d-flex justify-content-center mt-2'>
          <input
            type='text'
            className='form-control'
            placeholder='Condition Name...'
            style={{ textAlign: 'center' }}
            onChange={(e) => setConditionName(e.target.value)}
          />
        </div>
      </div>
      <div className='row d-flex justify-content-center pt-4 pt-lg-0'>
        <div className='col-md-6 d-flex justify-content-center mt-2'>
          <textarea
            type='text'
            className='form-control'
            placeholder='Condition Description...'
            style={{ textAlign: 'center' }}
            onChange={(e) => setConditionDesc(e.target.value)}
          />
        </div>
      </div>
      {typeof conditionName === 'string' && conditionName.length ? (
        <div className='row d-flex ustify-content-center pt-4 pt-lg-0'>
          <div className='col-lg-12 d-flex justify-content-center mt-4 pt-lg-0 slide-in-right'>
            <h3>
              <i className='fa-solid fa-table'></i> Select Tables
            </h3>
          </div>
          <div className='col-lg-12 d-flex justify-content-center'>
            <small>Found ({tables.length}) Tables </small>
          </div>
          <div className='col-lg-12 d-flex justify-content-center mt-2 pt-lg-0' data-aos='fade-up' data-aos-delay='200'>
            <Autocomplete
              options={tables.filter((table) => !selectedTables.includes(table))}
              getOptionLabel={(option) => option}
              //   value={selectedTable}
              onChange={(event, newValue) => {
                if (!tables.includes(newValue)) return null;
                return setSelectedTables((state) =>
                  state.includes(newValue) ? state.filter((flt) => flt !== newValue) : [...state, newValue]
                );
              }}
              renderInput={(params) => <TextField {...params} label='Select Tables' variant='outlined' />}
              style={{ width: 300 }}
            />
          </div>
          {selectedTables.length ? (
            <>
              <div className='col-lg-12 d-flex justify-content-center mt-4 pt-lg-0 flex-wrap'>
                {selectedTables.map((table) => {
                  return (
                    <div key={table} className='btn-group m-1' data-aos='fade-up' data-aos-delay='200'>
                      <div className='btn btn-sm btn-outline-primary'>
                        <b>{table}</b>
                      </div>
                      <button
                        title='Click to Remove'
                        className='btn btn-sm btn-outline-dark'
                        onClick={() => setSelectedTables((state) => state.filter((flt) => flt !== table))}
                      >
                        X
                      </button>
                    </div>
                  );
                })}
              </div>
              <div className='col-lg-12 d-flex justify-content-center mt-2 pt-lg-0 flex-wrap'>
                <button
                  className='btn btn-lg btn-outline-success'
                  disabled={loadingColumns}
                  onClick={() => {
                    dispatch(generalSet({ reduxField: 'loadingColumns', value: true }));
                    dispatch(
                      apiAction({
                        reduxField: 'columns',
                        route: 'mmData/getTableColumns',
                        tableNames: selectedTables,
                        setLoading: 'loadingColumns',
                      })
                    );
                  }}
                >
                  {loadingColumns ? 'Loading Columns...' : 'Get Columns'}
                </button>
              </div>
            </>
          ) : null}
        </div>
      ) : null}
      {Array.isArray(columns) && columns.length ? (
        <>
          <div className='row d-flex justify-content-center mt-4 pt-lg-0'>
            <div className='col-lg-12 d-flex justify-content-center pt-lg-0' data-aos='fade-up' data-aos-delay='200'>
              <h3>
                <i className='fas fa-columns'></i> Select Columns
              </h3>{' '}
            </div>
            <div className='col-lg-8 d-flex justify-content-center ' data-aos='fade-up' data-aos-delay='200'>
              <button
                className='btn btn-sm btn-outline-dark ml-auto'
                onClick={() => {
                  const allColumns = [];
                  columns.map((c) => c.columns?.map((col) => allColumns.push(col)));
                  setSelectedColumns(allColumns);
                }}
              >
                Select All Columns
              </button>
            </div>
          </div>
          {selectedColumns.length ? (
            <>
              <div
                className='row d-flex justify-content-center pt-4 pt-lg-0 mt-4 mb-4'
                data-aos='fade-up'
                data-aos-delay='200'
              >
                <button
                  className='btn btn-lg btn-success'
                  disabled={loadingNewCondition}
                  onClick={() => {
                    dispatch(generalSet({ reduxField: 'loadingNewCondition', value: true }));
                    dispatch(
                      apiAction({
                        reduxField: 'newCondition',
                        route: 'conditions/createCondition',
                        name: conditionName,
                        description: conditionDesc,
                        columns: selectedColumns,
                        setLoading: 'loadingNewCondition',
                      })
                    );
                  }}
                >
                  {loadingNewCondition
                    ? 'Creating Condition...'
                    : `Create a Condition with (${selectedColumns.length}) Columns`}
                </button>
              </div>
            </>
          ) : null}
          {columns
            .filter((flt) => Array.isArray(flt.columns))
            .map((column) => {
              return (
                <div
                  className='row d-flex justify-content-center pt-4 pt-lg-0 mb-2'
                  data-aos='fade-up'
                  data-aos-delay='200'
                  key={column.table_name}
                >
                  <div className='col-md-8 d-flex justify-content-center p-2 border border-bottom-0'>
                    <h6>
                      <i className='fa-solid fa-table'></i> {column.table_name}
                    </h6>
                  </div>
                  <div className='col-md-8 d-flex justify-content-center p-2 flex-wrap border border-top-0'>
                    {column.columns.map((col) => {
                      return (
                        <button
                          key={col.column_name}
                          className={`btn btn-sm btn${
                            selectedColumns.filter(
                              (flt) => flt.table_name === column.table_name && flt.column_name === col.column_name
                            )[0]
                              ? ''
                              : '-outline'
                          }-primary m-1`}
                          onClick={() =>
                            selectedColumns.includes(col)
                              ? setSelectedColumns(selectedColumns.filter((flt) => flt !== col))
                              : setSelectedColumns([...selectedColumns, col])
                          }
                        >
                          {col.column_name}
                        </button>
                      );
                    })}
                  </div>
                </div>
              );
            })}
        </>
      ) : null}
    </div>
  ) : (
    <Spinner />
  );
};

export default NewCondition;
